import { render } from "./LeftoversExplanation.vue?vue&type=template&id=a7f9bc8a&scoped=true"
import script from "./LeftoversExplanation.vue?vue&type=script&lang=js"
export * from "./LeftoversExplanation.vue?vue&type=script&lang=js"

import "./LeftoversExplanation.vue?vue&type=style&index=0&id=a7f9bc8a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7f9bc8a"]])

export default __exports__